export default __webpack_public_path__ + "static/media/caca.36b71df7.jpeg";